import { useMemo } from 'react';
import { useLiveQuery } from 'dexie-react-hooks';
import { listProposalBundles } from '@/db/proposalBundles';
import type { ProposalBundleRecord } from '@/db/codexDB';
import { useProject } from './selectors';

/** 대기(proposed) 제안 — 승인 큐의 라이브 소스(K2). 모든 분산 배지가 이걸 본다. */
export function usePendingProposals(): ProposalBundleRecord[] {
  const project = useProject();
  return (
    useLiveQuery(
      () => (project ? listProposalBundles(project.id, 'proposed') : Promise.resolve([] as ProposalBundleRecord[])),
      [project?.id],
      [] as ProposalBundleRecord[],
    ) ?? []
  );
}

/** 비트 id → 그 비트에 닿는 대기 제안 수(파급 ripple.beat + 지점 제안 fixes.beatId). 도메인 분산 배지의 근거. */
export function proposalBeatMap(pending: ProposalBundleRecord[]): Record<string, number> {
  const map: Record<string, number> = {};
  for (const p of pending) {
    const beats = new Set<string>();
    for (const r of p.ripple) beats.add(r.beat);
    for (const f of p.fixes) beats.add(f.beatId);
    for (const b of beats) map[b] = (map[b] ?? 0) + 1;
  }
  return map;
}

export function useProposalBeatMap(): Record<string, number> {
  const pending = usePendingProposals();
  return useMemo(() => proposalBeatMap(pending), [pending]);
}
